import FilePickerHandler from './OfficeEditorImageFilePickerHandler';

export default FilePickerHandler;
